module.exports = __webpack_public_path__ + "static/media/beta.4f7d80d6.svg";